import ServiceDetailPage from "./ServiceDetailPage";
import serviceContent from "./serviceContent";

const BrandIdentity = () => <ServiceDetailPage service={serviceContent.brandIdentity} />;

export default BrandIdentity;
